/* eslint-disable react-hooks/exhaustive-deps */
import {MapView} from '../MapView'
import {useContext, useEffect, useMemo, useState} from 'react'
import {DataContext} from '../../context/DataContext'
import {HeaderPerformance} from '../Common/HeaderPerformance'
import {formatDistancia, formatNumber} from '../../../explorer/components/common'
import {FilterContext} from '../../context/FilterContext'
import {BiCircle, BiInfoCircle, BiPlus, BiSolidCircle, BiTrash} from 'react-icons/bi'
import {Tipologia} from '../Types'
import {MaisInfoEmpreendimentos} from '../MaisInfoEmpreendimentos'
import {
  FilterRange,
  FilterSelect,
  RangeColumnFilter,
  SelectColumnFilter,
} from '../../../../components/UI/TableContainer/filters'
import TableContainer from '../../../../components/UI/TableContainer'
import {be} from 'date-fns/locale'
import {color} from 'html2canvas/dist/types/css/types/color'
import {mean, median} from 'simple-statistics'
import {PropsResultado} from '../CheckServices'

import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {GetVSOChosen} from '../../../../components/UI/Chosens/GetVSOChosen'
import {QueryGetEmpreendimentoImovelIntersect} from '../../../../graphql/services/inteligencia-mercado'
import {Marker} from '@react-google-maps/api'
import secureLocalStorage from 'react-secure-storage'

type Props = {
  label?: string
}
type PropMenu = {
  show: boolean
  id: number
}
// type PropFilter = {
//   empreendimento: string
//   incorporadora: string
// }

type FaixaRenda = {
  faixa_renda: string
  total_dom: number
  id_faixa: string
}
type EstudoDemandaRow = {
  rendaMediaDomiciliar: string
  faixaPrecoImovel: string
  domicilios: number | string
  estimativaNovosDomicilios: string | number
  unidadesLancadas: number | string
  estoque: {value: string; color: string}
  vendaMediaMensal: number | string
  mesesAbsorcao: number | string
  dorm1: {value: string; color: string}
  dorm2: {value: string; color: string}
  dorm3: {value: string; color: string}
  dorm4: {value: string; color: string}
  landbank: number | string
  mesesDemanda: {value: string; color: string}
}

const FAIXAS = [
  [
    ['', 0, 4500, 'faixa_0'],
    ['', 4500, 8200, 'faixa_1'],
    ['', 8200, 13500, 'faixa_2'],
    ['', 13500, 20000, 'faixa_3'],
    ['', 20000, 27000, 'faixa_4'],
    ['', 27000, 40000, 'faixa_5'],
    ['', 40000, 0, 'faixa_6'],
  ],

  [
    ['', 0, 27000, 'faixa_7'],
    ['', 27000, 40000, 'faixa_8'],
    ['', 40000, 54000, 'faixa_9'],
    ['', 54000, 67000, 'faixa_10'],
    ['', 67000, 80500, 'faixa_11'],
    ['', 80500, 93000, 'faixa_12'],
    ['', 93000, 0, 'faixa_13'],
  ],
  [
    ['Faixa 1', 0, 3200, 'faixa_14'],
    ['Faixa 2', 3200, 5000, 'faixa_15'],
    ['Faixa 3 Inferior', 5000, 6900, 'faixa_16'],
    ['Faixa 3 Superior', 6900, 9600, 'faixa_17'],
    ['Faixa 4', 9600, 13000, 'faixa_18'],
    ['Média-alta ', 13000, 20000, 'faixa_19'],
    ['Alta Renda', 20000, 0, 'faixa_20'],
  ],
]

export function EstudoDemanda({label}: Props) {
  const {
    data,
    removeItemTipologia,
    addItemTipologia,
    segmentacao,
    cacheResult,
    setCacheResult,
    vsoIdeal: VSO_IDEAL,
    setVsoIdeal,
  } = useContext(DataContext)

  const {endereco, geometriaSelecionada, filter, geometria} = useContext(FilterContext)
  const [logoSizes, setLogoSizes] = useState<Record<string, {w: number; h: number}>>({})
  const [estoqueMultiplicador, setEstoqueMultiplicador] = useState<number>(1)
  const [multiploDemandaFutura, setMultiploDemandaFutura] = useState<number>(1)
  // const [resetPaginationToggle, setResetPaginationToggle] = useState(false)
  // const [dataComputados, setDataComputados] = useState([])
  const [dataClientState, setDataClientState] = useState<any[]>([])
  const [faixasRendaDomTotal, setFaixaRendaDomTotal] = useState<FaixaRenda[]>([])
  // const [dataNaoComputados, setDataNaoComputados] = useState([])
  // const [filterText, setFilterText] = useState<PropFilter>({
  //   empreendimento: null,
  //   incorporadora: null,
  // })
  let logo = `https://app.urbit.com.br/media/logos/logo.png`
  const logoEmpresa: any = secureLocalStorage.getItem('user_logo_empresa')
  if (logoEmpresa) {
    logo = logoEmpresa
  }

  useEffect(() => {
    if (!data) {
      return
    }
    let isMounted = true
    const pendingImages: HTMLImageElement[] = []

    if (logo && !logoSizes[logo]) {
      const img = new Image()
      img.onload = () => {
        if (!isMounted) {
          return
        }
        setLogoSizes((prev) => ({
          ...prev,
          [logo]: {w: img.naturalWidth || img.width, h: img.naturalHeight || img.height},
        }))
      }
      img.src = logo
      pendingImages.push(img)
    }

    return () => {
      isMounted = false
      pendingImages.forEach((img) => {
        img.onload = null
        img.onerror = null
      })
    }
  }, [data, logoSizes])

  const {
    data: dataCliente,
    error,
    loading,
  } = QueryGetEmpreendimentoImovelIntersect({
    variables: {
      pagination: {
        pagina: 1,
        quantidade: 10000,
      },
      payloadBase64: btoa(unescape(encodeURIComponent(JSON.stringify(geometria)))),

      // filter: {
      //   fields: filter,
      // },
    },
    skip: !geometria,
  })

  useEffect(() => {
    if (cacheResult.sociodemografico) {
      const faixaRendaDomTotal = cacheResult.sociodemografico.filter(
        (item) => item.servico === 'dom-total-faixa-renda-v2'
      )[0]
      setFaixaRendaDomTotal(faixaRendaDomTotal?.resultado?.itens || [])
    }
  }, [cacheResult.sociodemografico])

  useEffect(() => {
    if (dataCliente?.GetEmpreendimentoImovelIntersect?.result) {
      // dataCliente.GetEmpreendimentoImovelIntersect.result.map(()=>{

      // })

      setDataClientState(dataCliente.GetEmpreendimentoImovelIntersect.result)
      return
    }
    if (error) {
      setDataClientState([])
    }
  }, [dataCliente, error])
  const [show, setShow] = useState<PropMenu>({
    show: false,
    id: null,
  })
  const layersList = [] //getLayers(['view_ibge_explorer_renda_mensal_domiciliar'], json)
  const dataTable = []
  const dataTableNaoComputados = []

  useEffect(() => {
    if (!data) {
      return
    }
    // eslint-disable-next-line array-callback-return
    data.map((item) => {
      // eslint-disable-next-line array-callback-return
      item.tipologias.map((itemTipologia: Tipologia) => {
        if (itemTipologia.computed) {
          dataTable.push({
            id: itemTipologia.id_tipologia,
            id_empreendimento: item.id_empreendimento,
            id_empreendimento_orulo: item.id_empreendimento_orulo,
            nome: item.nome,
            incorporadora: item.nome_incorporador,
            endereco: item.endereco,
            quartos: itemTipologia.bedrooms,
            data_lancamento: item.data_lancamento,
            area_privativa: itemTipologia.private_area,
            total_unidades: itemTipologia.total_units,
            vso: itemTipologia.vendas_perc_tip,
            estoque: itemTipologia.stock,
            vagas: itemTipologia.parking,
            preco_m2: itemTipologia.preco_corrigido_incc / itemTipologia.private_area,
            preco_total: itemTipologia.preco_corrigido_incc,
            bairro: item.bairro,
            distancia: item.distancia,
            tipo: itemTipologia.type,
            affordable_program: item.affordable_program === 1 ? 'Sim' : 'Não',
          })
        } else {
          dataTableNaoComputados.push({
            id: itemTipologia.id_tipologia,
            id_empreendimento: item.id_empreendimento,
            id_empreendimento_orulo: item.id_empreendimento_orulo,
            nome: item.nome,
            incorporadora: item.nome_incorporador,
            endereco: item.endereco,
            quartos: itemTipologia.bedrooms,
            data_lancamento: item.data_lancamento,
            area_privativa: itemTipologia.private_area,
            total_unidades: itemTipologia.total_units,
            vso: itemTipologia.vendas_perc_tip,
            estoque: itemTipologia.stock,
            vagas: itemTipologia.parking,
            preco_m2: itemTipologia.original_price / itemTipologia.private_area,
            preco_total: itemTipologia.original_price,
            bairro: item.bairro,
            distancia: item.distancia,
            tipo: itemTipologia.type,
            affordable_program: item.affordable_program === 1 ? 'Sim' : 'Não',
          })
        }
      })

      // setDataComputados(dataTable)
      // setDataNaoComputados(dataTableNaoComputados)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const defaultMetrics = useMemo(
    () => ({
      unidadeLancadas: Array(7).fill(0, 0, 7),
      estoque: Array(7).fill(0, 0, 7),
      estoqueTipologia: Array.from({length: 7}, () => []),
      estoqueTipologiaDorms: Array.from({length: 7}, () => 0),
      mesesAbsorcao: Array(7).fill(0, 0, 7),
      vsoIdealTipologia: Array.from({length: 7}, () => []),
      vsoFinal: Array.from({length: 7}, () => []),
      vsoIdeal: Array.from({length: 7}, () => []),
      vendaMensal: Array.from({length: 7}, () => []),
      vendasTotalTipologias: Array.from({length: 7}, () => []),
      vendasPonderadaTipologias: Array.from({length: 7}, () => []),
      vendasTotalTipologiasDorms: Array.from({length: 7}, () => []),
      vendasPonderadaTipologiasDorms: Array.from({length: 7}, () => []),
      landBank: Array.from({length: 7}, () => []),
      tempoMedioVenda: Array.from({length: 7}, () => 0),
      tempoMedioVendaDormsMesesMercado: Array.from({length: 7}, () => 0),
    }),
    []
  )

  const {
    unidadeLancadas,
    estoque,
    estoqueTipologia,
    mesesAbsorcao,
    vsoIdealTipologia,
    vsoFinal,
    vsoIdeal,
    vendaMensal,
    vendasTotalTipologias,
    vendasPonderadaTipologias,
    vendasTotalTipologiasDorms,
    vendasPonderadaTipologiasDorms,
    estoqueTipologiaDorms,
    tempoMedioVenda,
    tempoMedioVendaDormsMesesMercado,
  } = useMemo(() => {
    if (!data) {
      return defaultMetrics
    }

    const unidadeLancadas = Array(7).fill(0, 0, 7)
    const estoque = Array(7).fill(0, 0, 7)
    const vendas = Array(7).fill(0, 0, 7)
    const vendaMensal = Array.from({length: 7}, () => [])
    const vendasTotalTipologias = Array.from({length: 7}, () => [])
    const vendasPonderadaTipologias = Array.from({length: 7}, () => [])
    const tempoMedioVenda = Array.from({length: 7}, () => 0)

    const estoqueTipologia = Array.from({length: 7}, () => [])

    const mesesAbsorcao = Array(7).fill(0, 0, 7)
    const totalUnidadesTipologias = Array.from({length: 7}, () => [])
    const vendasTotalTipologiasDorms = Array.from({length: 7}, () => [])
    const vendasPonderadaTipologiasDorms = Array.from({length: 7}, () => [])
    const tempoMedioVendaDormsMesesMercado = Array.from({length: 7}, () => 0)
    const estoqueTipologiaDorms = Array.from({length: 7}, () => 0)

    const vsoIdealTipologia = Array.from({length: 7}, () => [])

    if (data && filter.segmentacaoPreco !== null) {
      // eslint-disable-next-line array-callback-return
      data.map((item) => {
        // eslint-disable-next-line array-callback-return
        item.tipologias.map((itemTipologias) => {
          let preco = itemTipologias.preco_corrigido_incc // || itemTipologias.preco_lancamento || itemTipologias.original_price

          if (itemTipologias.computed && preco > 0) {
            const totalUnits = Number(itemTipologias.total_units) || 0
            const stockValue = Number(itemTipologias.stock) || 0
            const tempo = item.meses_ate_lancamento || 0
            segmentacao.preco[filter.segmentacaoPreco].forEach((faixas, i) => {
              if (i === 6) {
                if (preco >= faixas[0]) {
                  const vsoIdealValue = VSO_IDEAL[item.fase_projeto_ideal]?.vso ?? 0

                  let bedroomIndex = Number(itemTipologias.bedrooms) || 0

                  if (itemTipologias.bedrooms === 0) {
                    bedroomIndex = 1
                  }

                  unidadeLancadas[i] = unidadeLancadas[i] + totalUnits
                  estoque[i] = estoque[i] + stockValue

                  if (!Number.isFinite(estoqueTipologia[i][bedroomIndex])) {
                    estoqueTipologia[i][bedroomIndex] = 0
                  }

                  // console.log('I', i)

                  // console.log('itemTipologias.stock', itemTipologias.stock)
                  // console.log('bedroomIndex', bedroomIndex)
                  // console.log(estoqueTipologia)
                  // console.log('******************************')
                  estoqueTipologia[i][bedroomIndex] = estoqueTipologia[i][bedroomIndex] + stockValue

                  if (!Number.isFinite(totalUnidadesTipologias[i][bedroomIndex])) {
                    totalUnidadesTipologias[i][bedroomIndex] = 0
                  }
                  totalUnidadesTipologias[i][bedroomIndex] =
                    totalUnidadesTipologias[i][bedroomIndex] + totalUnits

                  if (!Number.isFinite(vsoIdealTipologia[i][bedroomIndex])) {
                    vsoIdealTipologia[i][bedroomIndex] = 0
                  }
                  vsoIdealTipologia[i][bedroomIndex] +=
                    (itemTipologias.vendas_perc_tip - vsoIdealValue) * totalUnits

                  if (!Number.isFinite(tempoMedioVenda[i])) {
                    tempoMedioVenda[i] = 0
                  }

                  tempoMedioVenda[i] += itemTipologias.meses_mercado * (totalUnits - stockValue)

                  vendaMensal[i].push(itemTipologias.venda_mensal)
                  vendasTotalTipologias[i].push(totalUnits - stockValue)

                  vendasPonderadaTipologias[i].push(
                    itemTipologias.venda_mensal * (totalUnits - stockValue)
                  )

                  // if (!Number.isFinite(vendasTotalTipologiasDorms[bedroomIndex])) {
                  //   vendasTotalTipologiasDorms[bedroomIndex] = []
                  // }
                  vendasTotalTipologiasDorms[bedroomIndex].push(totalUnits - stockValue)

                  // if (!Number.isFinite(vendasPonderadaTipologiasDorms[bedroomIndex])) {
                  //   vendasPonderadaTipologiasDorms[bedroomIndex] = []
                  // }
                  vendasPonderadaTipologiasDorms[bedroomIndex].push(totalUnits - stockValue)

                  if (!Number.isFinite(tempoMedioVendaDormsMesesMercado[bedroomIndex])) {
                    tempoMedioVendaDormsMesesMercado[bedroomIndex] = 0
                  }
                  tempoMedioVendaDormsMesesMercado[bedroomIndex] +=
                    itemTipologias.meses_mercado * (totalUnits - stockValue)

                  if (!Number.isFinite(estoqueTipologiaDorms[bedroomIndex])) {
                    estoqueTipologiaDorms[bedroomIndex] = 0
                  }

                  estoqueTipologiaDorms[bedroomIndex] =
                    estoqueTipologiaDorms[bedroomIndex] + stockValue
                }
              } else if (preco >= faixas[0] && preco < faixas[1]) {
                const vsoIdealValue = VSO_IDEAL[item.fase_projeto_ideal]?.vso ?? 0
                const bedroomIndex = Number(itemTipologias.bedrooms) || 0
                unidadeLancadas[i] = unidadeLancadas[i] + totalUnits
                estoque[i] = estoque[i] + stockValue

                // console.log('I', i)
                // console.log('itemTipologias', itemTipologias)
                // console.log('itemTipologias.stock', itemTipologias.stock)
                // console.log('bedroomIndex', bedroomIndex)
                // console.log(estoqueTipologia)
                // console.log('******************************')

                if (!Number.isFinite(estoqueTipologia[i][bedroomIndex])) {
                  estoqueTipologia[i][bedroomIndex] = 0
                }
                estoqueTipologia[i][bedroomIndex] = estoqueTipologia[i][bedroomIndex] + stockValue

                if (!Number.isFinite(totalUnidadesTipologias[i][bedroomIndex])) {
                  totalUnidadesTipologias[i][bedroomIndex] = 0
                }
                totalUnidadesTipologias[i][bedroomIndex] =
                  totalUnidadesTipologias[i][bedroomIndex] + totalUnits

                if (!Number.isFinite(vsoIdealTipologia[i][bedroomIndex])) {
                  vsoIdealTipologia[i][bedroomIndex] = 0
                }
                vsoIdealTipologia[i][bedroomIndex] +=
                  (itemTipologias.vendas_perc_tip - vsoIdealValue) * totalUnits // Math.floor((vsoIdealValue / 100) * totalUnits)

                if (!Number.isFinite(tempoMedioVenda[i])) {
                  tempoMedioVenda[i] = 0
                }

                tempoMedioVenda[i] += itemTipologias.meses_mercado * (totalUnits - stockValue)

                vendaMensal[i].push(itemTipologias.venda_mensal)
                vendasPonderadaTipologias[i].push(
                  itemTipologias.venda_mensal * (totalUnits - stockValue)
                )
                vendasTotalTipologias[i].push(totalUnits - stockValue)

                // if (!Number.isFinite(vendasTotalTipologiasDorms[bedroomIndex])) {
                //   vendasTotalTipologiasDorms[bedroomIndex] = []
                // }
                vendasTotalTipologiasDorms[bedroomIndex].push(totalUnits - stockValue)

                // if (!Number.isFinite(vendasPonderadaTipologiasDorms[bedroomIndex])) {
                //   vendasPonderadaTipologiasDorms[bedroomIndex] = []
                // }

                if (!Number.isFinite(tempoMedioVendaDormsMesesMercado[bedroomIndex])) {
                  tempoMedioVendaDormsMesesMercado[bedroomIndex] = 0
                }
                tempoMedioVendaDormsMesesMercado[bedroomIndex] +=
                  itemTipologias.meses_mercado * (totalUnits - stockValue)

                // console.log(itemTipologias.venda_mensal)
                vendasPonderadaTipologiasDorms[bedroomIndex].push(totalUnits - stockValue)
                // vendasPonderadaTipologiasDorms[bedroomIndex].push(itemTipologias.venda_mensal)
                if (!Number.isFinite(estoqueTipologiaDorms[bedroomIndex])) {
                  estoqueTipologiaDorms[bedroomIndex] = 0
                }

                estoqueTipologiaDorms[bedroomIndex] =
                  estoqueTipologiaDorms[bedroomIndex] + stockValue
              }
            })
          }
        })
      })
    }

    const vsoFinal = Array.from({length: 7}, () => [])
    const vsoIdeal = Array.from({length: 7}, () => [])
    vsoIdealTipologia.map((item, index) => {
      item.map((value, bedroomIndex) => {
        if (totalUnidadesTipologias[index][bedroomIndex] > 0) {
          let diffVso =
            vsoIdealTipologia[index][bedroomIndex] / totalUnidadesTipologias[index][bedroomIndex]

          // let vso = Math.round(
          //   ((totalUnidadesTipologias[index][bedroomIndex] - estoqueTipologia[index][bedroomIndex]) /
          //     totalUnidadesTipologias[index][bedroomIndex]) *
          //     100
          // )
          vsoFinal[index][bedroomIndex] = diffVso
          vsoIdeal[index][bedroomIndex] = Math.round(
            (value / totalUnidadesTipologias[index][bedroomIndex]) * 100
          )
        } else {
          vsoFinal[index][bedroomIndex] = 0
          vsoIdeal[index][bedroomIndex] = 0
        }
      })
    })

    return {
      unidadeLancadas,
      estoque,
      estoqueTipologia,
      estoqueTipologiaDorms,
      mesesAbsorcao,
      vsoIdealTipologia,
      vsoFinal,
      vsoIdeal,
      vendaMensal,
      vendasTotalTipologias,
      vendasPonderadaTipologias,
      vendasTotalTipologiasDorms,
      vendasPonderadaTipologiasDorms,
      tempoMedioVenda,
      tempoMedioVendaDormsMesesMercado,
    }
  }, [
    data,
    filter.segmentacaoPreco,
    segmentacao.preco,
    VSO_IDEAL,
    defaultMetrics,
    estoqueMultiplicador,
  ])

  const faixas = FAIXAS[filter.segmentacaoPreco]

  function getDomTotalPorFaixaRenda(id_faixa: string) {
    const result = faixasRendaDomTotal.filter((item) => {
      return item.id_faixa === id_faixa
    })

    if (result.length > 0) {
      return result[0].total_dom
    } else {
      return 0
    }
  }

  const estudoDemandaRows = cacheResult.estudoDemanda || []
  const estudoSocioDemografico = cacheResult.sociodemografico || []

  useEffect(() => {
    if (!segmentacao?.preco || filter.segmentacaoPreco === null) {
      setCacheResult((prev) => ({...prev, estudoDemanda: []}))
      return
    }
    if (!faixasRendaDomTotal.length) {
      return
    }
    const dom_total_2010 = getServicoResultByName(
      estudoSocioDemografico,
      'renda-domiciliar-intersect',
      'dom_total'
    )
    const dom_total_2022 = getServicoResultByName(
      estudoSocioDemografico,
      'populacao-domicilios-censo-2022',
      'domicilios'
    )
    if (!dom_total_2010 || !dom_total_2022) {
      return
    }
    const faixaSegmentada = segmentacao.preco[filter.segmentacaoPreco]

    let dorms = []

    function calcularTgca(dom_total_faixa_renda: number) {
      const ano_atual = new Date().getFullYear()
      const tgca = Math.pow(dom_total_2022 / dom_total_2010, 1 / 12) - 1
      const dom_atual = dom_total_faixa_renda * Math.pow(1 + tgca, ano_atual - 2010)
      const dom_anual = (dom_atual - dom_total_faixa_renda) / (ano_atual - 2010)
      return {dom_atual: dom_atual.toFixed(0), dom_anual: dom_anual.toFixed(0)}
    }

    const rows: EstudoDemandaRow[] = faixaSegmentada.map((item, indexFaixa) => {
      let rendaMediaDomiciliar = ''
      let faixaPrecoImovel = ''
      if (typeof dorms[indexFaixa] === 'undefined') {
        dorms[indexFaixa] = []
      }
      if (indexFaixa === 0) {
        rendaMediaDomiciliar = `${
          faixas[indexFaixa][0] ? faixas[indexFaixa][0] + ' - ' : ''
        }  menor que ${formatNumber(faixas[indexFaixa][2], 'currency')}`
        faixaPrecoImovel = `até ${formatNumber(item[1], 'currency')}`
      } else if (indexFaixa === 6) {

        rendaMediaDomiciliar = `${
          faixas[indexFaixa][0] ? faixas[indexFaixa][0] + ' - ' : ''
        }  maior que ${formatNumber(faixas[indexFaixa][1], 'currency')}`
        faixaPrecoImovel = `maior que ${formatNumber(item[0], 'currency')}`
      } else {


        rendaMediaDomiciliar = `${faixas[indexFaixa][0]} de ${formatNumber(
          faixas[indexFaixa][1],
          'currency'
        )} até ${formatNumber(faixas[indexFaixa][2], 'currency')}`

        faixaPrecoImovel = `${formatNumber(item[0], 'currency')} até ${formatNumber(
          item[1],
          'currency'
        )}`
      }

      dorms[indexFaixa] = {
        dorm1: {value: 0, color: '', vsoFinal: 0, vsoIdeal: 0},
        dorm2: {value: 0, color: '', vsoFinal: 0, vsoIdeal: 0},
        dorm3: {value: 0, color: '', vsoFinal: 0, vsoIdeal: 0},
        dorm4: {value: 0, color: '', vsoFinal: 0, vsoIdeal: 0},
      }

      const vsoFaixa = vsoFinal[indexFaixa] || []
      const vsoIdealFaixa = vsoIdeal[indexFaixa] || []

      if (vsoFaixa.length > 0) {
        vsoFaixa.map((value, bedroomIndex) => {
          const idealValue = Number(vsoIdealFaixa[bedroomIndex]) || 0
          const vso_dif = ((36 * (value - vsoIdealFaixa[bedroomIndex])) / 100) * -1

          if (bedroomIndex === 1) {
            let color = ''
            if (value <= idealValue) {
              color = 'green'
            } else if (value > idealValue && value <= idealValue + 10) {
              color = '#ffe600'
            } else {
              color = 'red'
            }
            dorms[indexFaixa].dorm1 = {
              value: value.toFixed(1) || '-',
              color: color,
              dorm: 1,
              estoque: estoqueTipologia[indexFaixa][bedroomIndex],
              vsoFinal: value,
              vsoIdeal: vsoIdealFaixa[bedroomIndex],
            }
          } else if (bedroomIndex === 2) {
            let color = ''
            if (value <= idealValue) {
              color = 'green'
            } else if (value > idealValue && value <= idealValue + 10) {
              color = '#ffe600'
            } else {
              color = 'red'
            }
            dorms[indexFaixa].dorm2 = {
              value: value.toFixed(1) || '-',
              color: color,

              dorm: estoqueTipologia[indexFaixa][bedroomIndex],
              estoque: estoqueTipologia[indexFaixa][bedroomIndex],
              vsoFinal: value,
              vsoIdeal: vsoIdealFaixa[bedroomIndex],
            }
          } else if (bedroomIndex === 3) {
            let color = ''
            if (value <= idealValue) {
              color = 'green'
            } else if (value > idealValue && value <= idealValue + 10) {
              color = '#ffe600'
            } else {
              color = 'red'
            }
            dorms[indexFaixa].dorm3 = {
              value: value.toFixed(1) || '-',
              color: color,

              dorm: 3,
              estoque: estoqueTipologia[indexFaixa][bedroomIndex],
              vsoFinal: value,
              vsoIdeal: vsoIdealFaixa[bedroomIndex],
            }
          } else if (bedroomIndex >= 4) {
            let color = ''
            if (value <= idealValue) {
              color = 'green'
            } else if (value > idealValue && value <= idealValue + 10) {
              color = '#ffe600'
            } else {
              color = 'red'
            }
            dorms[indexFaixa].dorm4 = {
              value: value.toFixed(1) || '-',
              color: color,

              dorm: 4,
              estoque: estoqueTipologia[indexFaixa][bedroomIndex],
              vsoFinal: value,
              vsoIdeal: vsoIdealFaixa[bedroomIndex],
            }
          } else {
            dorms[indexFaixa].dorm1 = {value: 0, color: '', estoque: 0}
          }
        })
      }

      //Definir a cor do estoque
      let color = ''
      const faixaTotalDom = getDomTotalPorFaixaRenda(String(faixas[indexFaixa][3]))

      if (estoque && faixaTotalDom) {
        const estoqueValue = (estoque[indexFaixa] / Number(faixaTotalDom)) * 100
        if (estoqueValue <= 20) {
          color = 'green'
        } else if (estoqueValue > 20 && estoqueValue <= 25) {
          color = '#ffe600'
        } else {
          color = 'red'
        }
      }

      const vendamesalpoderadaporfaixa = vendasPonderadaTipologias[indexFaixa].reduce(
        (acc, curr) => {
          return acc + curr
        },
        0
      )

      const totalvendasporfaixa = vendasTotalTipologias[indexFaixa].reduce((acc, curr) => {
        return acc + curr
      }, 0)

      let somaUnidadesClientesFaixa = 0
      dataClientState.map((dataClientObj) => {
        if (
          dataClientObj.ticket_medio_venda > item[0] &&
          dataClientObj.ticket_medio_venda < item[1]
        ) {
          somaUnidadesClientesFaixa += dataClientObj.unidades
        }
      })

      const tempoMedioVendaPonderado =
        tempoMedioVenda[indexFaixa] > 0 ? tempoMedioVenda[indexFaixa] / totalvendasporfaixa : 0

      let vendaMediaMesalPonderada = 0
      if (multiploDemandaFutura === 2) {
        vendaMediaMesalPonderada =
          totalvendasporfaixa > 0
            ? (totalvendasporfaixa / tempoMedioVendaPonderado) * estoqueMultiplicador
            : 0
      } else {
        vendaMediaMesalPonderada =
          totalvendasporfaixa > 0
            ? (totalvendasporfaixa / tempoMedioVendaPonderado) * multiploDemandaFutura
            : 0
      }

      // vendaMediaMesalPonderada =
      //   totalvendasporfaixa > 0 ? totalvendasporfaixa / tempoMedioVendaPonderado : 0

      const mesesDemanda =
        (somaUnidadesClientesFaixa + estoque[indexFaixa] * estoqueMultiplicador) /
        vendaMediaMesalPonderada
      let colorMesesDemanda = ''
      if (estoque && mesesDemanda) {
        if (mesesDemanda / 12 <= 1) {
          colorMesesDemanda = '#00ff73'
        } else if (mesesDemanda / 12 > 1 && mesesDemanda / 12 <= 2) {
          colorMesesDemanda = 'green'
        } else if (mesesDemanda / 12 > 2 && mesesDemanda / 12 <= 3) {
          colorMesesDemanda = '#fff200'
        } else {
          colorMesesDemanda = 'red'
        }
      }

      const estoqueabsorcao =
        vendaMediaMesalPonderada > 0
          ? (estoque[indexFaixa] * estoqueMultiplicador) / vendaMediaMesalPonderada
          : 0
      let colorEstoqueDemanda = ''
      if (estoqueabsorcao && mesesDemanda) {
        if (mesesDemanda / 12 <= 1) {
          colorEstoqueDemanda = '#00ff73'
        } else if (mesesDemanda / 12 > 1 && mesesDemanda / 12 <= 2) {
          colorEstoqueDemanda = '#054421'
        } else if (mesesDemanda / 12 > 2 && mesesDemanda / 12 <= 3) {
          colorEstoqueDemanda = '#fff200'
        } else {
          colorEstoqueDemanda = 'red'
        }
      }
      
      return {
        rendaMediaDomiciliar,
        faixaPrecoImovel: faixaPrecoImovel,
        domicilios: calcularTgca(faixaTotalDom).dom_atual || '-',
        estimativaNovosDomicilios: Number(calcularTgca(faixaTotalDom).dom_anual) * 5,
        unidadesLancadas: unidadeLancadas ? unidadeLancadas[indexFaixa] : '-',
        estoque: {value: estoque ? String(estoque[indexFaixa] * estoqueMultiplicador) : '-', color},
        estoque_absorcao: {
          value: estoqueabsorcao ? estoqueabsorcao.toFixed(0) : '-',
          color: colorEstoqueDemanda,
        },
        vendaMediaMensal: vendaMediaMesalPonderada > 0 ? vendaMediaMesalPonderada.toFixed(1) : '-',
        mesesAbsorcao:
          estoque[indexFaixa] > 0 && Number.isFinite(mesesDemanda)
            ? (estoque[indexFaixa] / vendaMediaMesalPonderada).toFixed(1)
            : '-',
        dorm1: dorms[indexFaixa].dorm1,
        dorm2: dorms[indexFaixa].dorm2,
        dorm3: dorms[indexFaixa].dorm3,
        dorm4: dorms[indexFaixa].dorm4,
        landbank: somaUnidadesClientesFaixa,
        mesesDemanda: {
          value:
            isNaN(mesesDemanda) || !Number.isFinite(mesesDemanda) ? '-' : mesesDemanda.toFixed(0),
          color: colorMesesDemanda,
        },
      }
    })

    const absorcaoTipologias = estoqueTipologiaDorms.map((item, indexDorms) => {
      const vendamesalpoderadaporfaixa = vendasPonderadaTipologiasDorms[indexDorms].reduce(
        (acc, curr) => {
          return acc + curr
        },
        0
      )
      const totalvendasporfaixa = vendasTotalTipologiasDorms[indexDorms].reduce((acc, curr) => {
        return acc + curr
      }, 0)

      const vendaMediaMesalPonderada =
        totalvendasporfaixa / (tempoMedioVendaDormsMesesMercado[indexDorms] / totalvendasporfaixa)

      const mesesAbsorcao =
        estoqueTipologiaDorms[indexDorms] > 0
          ? (estoqueTipologiaDorms[indexDorms] / vendaMediaMesalPonderada).toFixed(1)
          : '-'
      return {
        mesesAbsorcao: Number(mesesAbsorcao).toFixed(0),
        tipologia: indexDorms,
        estoque: estoqueTipologiaDorms[indexDorms],
        vendaMensal: vendaMediaMesalPonderada.toFixed(0),
      }
    })

    setCacheResult((prev) => ({
      ...prev,
      estudoDemanda: rows,
      absorcaoTipologias: absorcaoTipologias,
    }))
  }, [
    segmentacao,
    filter.segmentacaoPreco,
    faixasRendaDomTotal,
    unidadeLancadas,
    estoque,
    vsoFinal,
    vsoIdeal,
    vendaMensal,
    vendasTotalTipologias,
    vendasPonderadaTipologias,
    setCacheResult,
    faixas,
    estudoSocioDemografico,
    multiploDemandaFutura,
  ])

  if (!data) {
    return <>Carregando...</>
  }

  if (!faixasRendaDomTotal) {
    return <>Carregando...</>
  }

  function getServicoResultByName(
    resultado: PropsResultado,
    servicoName: string,
    variavel: string
  ) {
    if (resultado) {
      const servico = resultado.find((item) => item.servico === servicoName)
      return servico?.resultado?.itens?.[0]?.[variavel]
    }
  }

  function getServicoResult(resultado: PropsResultado, servicoName: string) {
    if (!resultado) {
      return []
    }
    const servico = resultado.find((item) => item.servico === servicoName)
    return servico?.resultado?.itens || []
  }

  const link = '#'
  const Link = ({
    id,
    children,
    title,
  }: {
    id: string
    children: React.ReactNode
    title: React.ReactNode
  }) => (
    <OverlayTrigger
      overlay={
        <Tooltip id={id} style={{minWidth: '350px'}}>
          {title}
        </Tooltip>
      }
    >
      <a
        href={link}
        onClick={(event) => {
          event.preventDefault()
        }}
      >
        {children}
      </a>
    </OverlayTrigger>
  )

  return (
    <>
      <div className=' d-flex flex-column justify-content-start p-10'>
        <HeaderPerformance titulo={'Estudo de Demanda'}>
          <div className='pull-left d-flex flex-row align-items-end gap-6'>
            <div className='d-flex flex-column w-200px'>
              <label className='form-label mb-1'>VSO</label>
              <GetVSOChosen
                idVso={0}
                setValue={(value) => {
                  setVsoIdeal(value)
                }}
              ></GetVSOChosen>
            </div>
            <div className='d-flex flex-column w-150px'>
              <label className='form-label mb-1'>
                Anos de projeção
                <Link
                  id={'1'}
                  title={
                    <>
                      Multiplica o estoque pelo valor selecionado.
                      <br /> É o prazo de lançamento(em anos) das unidades em landbank.
                    </>
                  }
                >
                  <BiInfoCircle size={20} className='ms-2'></BiInfoCircle>
                </Link>
              </label>
              <select
                className='form-select'
                value={estoqueMultiplicador}
                onChange={(event) => setEstoqueMultiplicador(Number(event.target.value))}
                style={{padding: '7px 15px'}}
              >
                {[1, 2, 3, 4, 5].map((value) => (
                  <option key={value} value={value}>
                    {value}
                  </option>
                ))}
              </select>
            </div>
            <div className='d-flex flex-column w-150px'>
              <label className='form-label mb-1'>
                Demanda futura
                <Link
                  id={'1'}
                  title={
                    <>
                      Multiplica o estoque pelo valor selecionado.
                      <br /> É o prazo de lançamento(em anos) das unidades em landbank.
                    </>
                  }
                >
                  <BiInfoCircle size={20} className='ms-2'></BiInfoCircle>
                </Link>
              </label>
              <select
                className='form-select'
                value={multiploDemandaFutura}
                onChange={(event) => setMultiploDemandaFutura(Number(event.target.value))}
                style={{padding: '7px 15px'}}
              >
                <option value={'1'}>Igual ao período anterior</option>
                <option value={'0.75'}>25% menor</option>
                <option value={'1.25'}>25% maior</option>
                <option value={'2'}>Múltiplo de anos</option>
              </select>
            </div>
          </div>
        </HeaderPerformance>
        <div className='content pt-5'>
          <div className='row'>
            <div className='col-12'>
              <div className='card bgi-no-repeat card-xl-stretch mb-xl-8 border-2 box-performance'>
                <div className='map-painel d-flex w-100'>
                  <div className='mapa col-12'>
                    <div className=' col-12 p-5 '>
                      <div className='table-responsive'>
                        <table
                          className='table  table-hover l gap-3 table-im'
                          cellPadding={15}
                          cellSpacing={15}
                        >
                          <thead>
                            <tr>
                              <th>Renda Média Domiciliar</th>
                              <th>Faixa de Preço Imóvel (R$)</th>
                              <th className='text-center d-flex'>
                                Domicílios (2026){' '}
                                <Link
                                  id={'2'}
                                  title={
                                    <>
                                      Estimativa de domicílios, calculada a partir da tendência
                                      observada entre os Censos 2022 e 2010.
                                    </>
                                  }
                                >
                                  <BiInfoCircle size={20}></BiInfoCircle>
                                </Link>
                              </th>
                              <th className='text-center'>
                                Estimativa Novos Domicílios (Próximos 5 anos)
                                <Link
                                  id={'3'}
                                  title={
                                    <>
                                      Estimativa da produção anual de domicílios, calculada a partir
                                      da taxa de crescimento observada entre os censos 2022 e 2010.
                                    </>
                                  }
                                >
                                  <BiInfoCircle size={20}></BiInfoCircle>
                                </Link>
                              </th>
                              <th className='text-center'>Unidades Lançadas</th>
                              <th className='text-center'>
                                Estoque{' '}
                                <Link
                                  id={'4'}
                                  title={
                                    <>
                                      Estoque sobre domicilios. <br />
                                      Verde - até 20% <br />
                                      Amarelo - 21% até 25%
                                      <br />
                                      Vermelho - acima de 25%
                                      <br />
                                    </>
                                  }
                                >
                                  <BiInfoCircle size={20} className='ms-2'></BiInfoCircle>
                                </Link>
                              </th>
                              <th className='text-center'>
                                Meses absorção do estoque{' '}
                                <Link
                                  id={'5'}
                                  title={
                                    <div>
                                      Quantidade de meses para vender 100% das unidades do estoque.{' '}
                                      <br />
                                      Verde Claro - abaixo de 1 ano
                                      <br />
                                      Verde Escuro - 1 a 2 anos
                                      <br />
                                      Amarelo - 2 a 3 anos
                                      <br />
                                      Vermelho - Acima de 3 anos.
                                      <br />
                                    </div>
                                  }
                                >
                                  <BiInfoCircle size={20} className='ms-2'></BiInfoCircle>
                                </Link>
                              </th>
                              <th className='text-center'>
                                Venda Média Mensal
                                <Link id={'6'} title={'Unidades Habitacionais/Mês'}>
                                  <BiInfoCircle size={20}></BiInfoCircle>
                                </Link>
                              </th>
                              {/* <th className='text-center'>
                                Meses Absorção{' '}
                                <Link
                                  id={1}
                                  title={'Quantidade de meses para absorver 100% do estoque.'}
                                >
                                  <BiInfoCircle size={20} className='me-2'></BiInfoCircle>
                                </Link>
                              </th> */}
                              <th className='text-center w-90px'>
                                1 Dorm
                                <Link
                                  id={'7'}
                                  title={
                                    <>
                                      Velocidade Ideal de Venda <br />
                                      Verde - Acima da Curva
                                      <br />
                                      Amarelo - Na Curva (+/- 5%)
                                      <br />
                                      Vermelho - Abaixo da Curva.
                                      <br />
                                      Número representa a diferença em pontos percentuais entre o
                                      vso ideal e o vso da faixa/tipologia.
                                    </>
                                  }
                                >
                                  <BiInfoCircle size={20} className='ms-2'></BiInfoCircle>
                                </Link>{' '}
                                (VSO/Estoque)
                              </th>
                              {/* <th className='text-center w-90px'>1 Dorm Estoque</th> */}

                              <th className='text-center'>2 Dorm (VSO/Estoque)</th>
                              {/* <th className='text-center w-90px'>2 Dorm Estoque</th> */}
                              <th className='text-center'>3 Dorm (VSO/Estoque)</th>
                              {/* <th className='text-center w-90px'>3 Dorm Estoque</th> */}
                              <th className='text-center'>4+ Dorm (VSO/Estoque)</th>
                              {/* <th className='text-center w-90px'>4+ Dorm Estoque</th> */}
                              <th className='text-center'>Landbank(UH)</th>
                              <th className='text-center'>Landbank(UH) + Estoque</th>
                              <th className='text-center'>
                                Meses Demanda{' '}
                                <Link
                                  id={'8'}
                                  title={
                                    <>
                                      Quantidade de meses para vender 100% das unidades do landbak e
                                      do estoque. <br />
                                      Verde Claro- Abaixo de 1 ano <br />
                                      Verde - 1 a 2 anos <br />
                                      Amarelo - 2 a 3 anos <br />
                                      Vermelho - Acima de 3 anos. <br />
                                    </>
                                  }
                                >
                                  <BiInfoCircle size={20} className='ms-2'></BiInfoCircle>
                                </Link>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {estudoDemandaRows.map((row, index) => {
                              return (
                                <tr key={index}>
                                  <td>{row.rendaMediaDomiciliar}</td>
                                  <td>{row.faixaPrecoImovel}</td>
                                  <td className='text-center'>{row.domicilios}</td>
                                  <td className='text-center w-100px'>
                                    {row.estimativaNovosDomicilios}
                                  </td>
                                  <td className='text-center'>{row.unidadesLancadas}</td>
                                  <td
                                    className={`text-center ${
                                      row.estoque.color ? 'font-line-im' : ''
                                    } `}
                                    style={{backgroundColor: row.estoque.color}}
                                  >
                                    {row.estoque.value}
                                  </td>
                                  <td
                                    className={`text-center ${
                                      row.estoque_absorcao.color ? 'font-line-im' : ''
                                    } `}
                                    style={{backgroundColor: row.estoque_absorcao.color}}
                                  >
                                    {row.estoque_absorcao.value}
                                  </td>
                                  <td className='text-center'>{row.vendaMediaMensal}</td>
                                  {/* <td className='text-center'>{row.mesesAbsorcao || '-'}</td> */}
                                  <td className='text-center w-80px'>
                                    {row.dorm1.value != null && row.dorm1.color ? (
                                      <>
                                        <BiSolidCircle
                                          style={{color: row.dorm1.color}}
                                          size={18}
                                        ></BiSolidCircle>
                                        {row.dorm1.value}
                                      </>
                                    ) : (
                                      '-'
                                    )}{' '}
                                    {row.dorm1.estoque >= 0 ? '/' + row.dorm1.estoque : ''}
                                  </td>
                                  {/* <td className='text-center w-80px'>{row.dorm1.estoque}</td> */}

                                  <td className='text-center w-80px'>
                                    {row.dorm2.value != null && row.dorm2.color ? (
                                      <>
                                        {' '}
                                        <BiSolidCircle
                                          style={{color: row.dorm2.color}}
                                          size={18}
                                        ></BiSolidCircle>
                                        {row.dorm2.value}
                                      </>
                                    ) : (
                                      '-'
                                    )}{' '}
                                    {row.dorm2.estoque >= 0 ? '/' + row.dorm2.estoque : ''}
                                  </td>
                                  {/* <td className='text-center w-80px'>{row.dorm2.estoque}</td> */}
                                  <td className=' text-center w-80px'>
                                    {row.dorm3.value != null && row.dorm3.color ? (
                                      <>
                                        {' '}
                                        <BiSolidCircle
                                          style={{color: row.dorm3.color}}
                                          size={18}
                                        ></BiSolidCircle>
                                        {row.dorm3.value}
                                      </>
                                    ) : (
                                      '-'
                                    )}
                                    {row.dorm3.estoque >= 0 ? '/' + row.dorm3.estoque : ''}
                                  </td>
                                  {/* <td className='text-center w-80px'></td> */}
                                  <td className='text-center w-80px'>
                                    {row.dorm4.value != null && row.dorm4.color ? (
                                      <>
                                        {' '}
                                        <BiSolidCircle
                                          style={{color: row.dorm4.color}}
                                          size={18}
                                        ></BiSolidCircle>
                                        {row.dorm4.value}
                                      </>
                                    ) : (
                                      '-'
                                    )}
                                    {row.dorm4.estoque >= 0 ? '/' + row.dorm4.estoque : ''}
                                  </td>
                                  {/* <td className='text-center w-80px'>{row.dorm4.estoque}</td> */}
                                  <td className='text-center'>{row.landbank}</td>
                                  <td className='text-center'>
                                    {Number(row.landbank) + Number(row.estoque.value)}
                                  </td>
                                  <td
                                    className={`text-center ${
                                      row.mesesDemanda.value !== '-' ? 'font-line-im' : ''
                                    } `}
                                    style={
                                      row.mesesDemanda.value !== '-' &&
                                      !isNaN(row.mesesDemanda.value)
                                        ? {
                                            backgroundColor: row.mesesDemanda.color,
                                            // color: '#333',
                                          }
                                        : {}
                                    }
                                  >
                                    {row.mesesDemanda.value}
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                      {/* <TableContainer columns={columns} data={dataComputados}></TableContainer> */}
                    </div>
                    {geometriaSelecionada ? (
                      <MapView
                        data={data}
                        layer={[layersList]}
                        zoom={14}
                        height='500px'
                        center={{lat: endereco.latitude, lng: endereco.longitude}}
                        geometria={geometriaSelecionada}
                      >
                        {dataCliente?.GetEmpreendimentoImovelIntersect?.result?.map((data, i) => {
                          return (
                            <Marker
                              key={i}
                              position={{
                                lat: data.geom.coordinates[1],
                                lng: data.geom.coordinates[0],
                              }}
                              label={{
                                text: data.nome.split('-')[0],
                                className: `marker-label`,
                                color: '#4d3838',
                              }}
                              icon={{
                                // scaledSize: new google.maps.Size(20, 20),
                                scaledSize: (() => {
                                  if (logo) {
                                    const logoSize = logoSizes[logo]
                                    const fixedHeight = 25
                                    if (logoSize?.w && logoSize?.h) {
                                      const ratio = logoSize.w / logoSize.h
                                      return new google.maps.Size(
                                        Math.max(20, Math.round(fixedHeight * ratio)),
                                        fixedHeight
                                      )
                                    }
                                    return new google.maps.Size(fixedHeight, fixedHeight)
                                  }
                                  return new google.maps.Size(20, 20)
                                })(),
                                // size: new google.maps.Size(40, 40),
                                url: logo,
                                // bj.removed
                                //   ? toAbsoluteUrl('/media/f81039c7-b68a-462c-b90a-ccbf0a11e4ec.png')
                                //   : toAbsoluteUrl('/media/75210de1-444b-4077-8a30-d4aa401ee39c.png'),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 0),
                              }}
                              animation={google.maps.Animation.DROP}
                            ></Marker>
                          )
                        })}
                      </MapView>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MaisInfoEmpreendimentos
        setShow={setShow}
        show={show}
        height={'calc(100vh)'}
      ></MaisInfoEmpreendimentos>
    </>
  )
}
